module.exports = __webpack_public_path__ + "images/emoji/round_pushpin.0eed1d2e696842eb0548.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/round_pushpin.png
// module id = F9WK
// module chunks = 1